import axios from "axios";
import { useContext } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { MsgContext } from "../../App";
import { API, MSG } from "./constantsFront";


/**
 * ログイン情報
 * @returns 
 */
function Login() {
  const location = useLocation();
  const navigate = useNavigate();
  let body = { authKey: API.API_KEY };

  // エラーメッセージ
  const { msg, setMsg } = useContext(MsgContext);

  const LoginAdmin = () => {

    //認証チェック
    axios.post("/m_staff/auth")
      .then(res => {
        if (res.status != 200) {
          setMsg(MSG.TIMEOUT_LOGIN);
          navigate("/G009AdminLogin");
        }
      });

  }

  // 管理者画面(G始まり)を表示したときはログインチェックを行う
  if (!location.pathname.startsWith("/G009")
    && location.pathname.startsWith("/G")) {
    return <LoginAdmin />;
  } else {
    return;
  }
}

export default Login;